import { clsx } from 'clsx';
import { FC } from 'react';

interface Props {
  type?: 'text' | 'fill';
  className?: string;
  /** Width of the element in percent or with a specific CSS unit */
  size?: number | string;
}

export const Skeleton: FC<Props> = ({ type = 'text', className, size }) => (
  <span
    className={clsx('Skeleton', `Skeleton-${type}`, className)}
    aria-hidden="true"
    style={{ width: typeof size === 'number' ? `${size}%` : size }}
  />
);
